module.exports = __webpack_public_path__ + "static/media/black_rook.44e2e5c4.svg";